import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'components/Dropdown/Dropdown';
import './style.scss';
/*
 *https://github.com/Adphorus/react-date-range
 */

export class CustomDueStatus extends Component {
  static propTypes = {
    className: PropTypes.string,
    onSave: PropTypes.func,
    optionType: PropTypes.string,
    dueStatus: PropTypes.string,
    fromDate: PropTypes.string,
    toDate: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.options = [
      { key: 0, value: 'Overdue'},
      { key: 1, value: 'Past due'}
    ];

    this.initialValue = null;

    if (props.fromDate && props.toDate) {
      this.options[1] = {
        key: 1,
        value: 'Past due',
        label: 'Past due from ' + props.fromDate + ' to ' + props.toDate + ' days'
      };
      this.initialValue = this.options[1];
    }
    if (props.fromDate && props.toDate === null) {
      this.options[1] = {
        key: 1,
        value: 'Past due',
        label: 'Past due >= ' + props.fromDate + ' days'
      };
      this.initialValue = this.options[1];
    }

    if (props.toDate && props.fromDate === null) {
      this.options[1] = {
        key: 1,
        value: 'Past due',
        label: 'Past due <= ' + props.toDate + ' days'
      };
      this.initialValue = this.options[1];
    }

    if (props.toDate === props.fromDate && props.toDate !== null & props.fromDate !== null) {
      this.options[1] = {
        key: 1,
        value: 'Past due',
        label: 'Past due = ' + props.toDate + ' days'
      };
      this.initialValue = this.options[1];
    }

    // if (props.dueStatus) {
    //   this.options[0] = {
    //     key: 0,
    //     value: 'Overdue',
    //     label: 'Overdue'
    //   };
    //   this.initialValue = this.options[0];
    // }

    if (props.optionType) {
      this.initialValue = this.options.find(x => x.value === props.optionType);
    }

    this.state = {
      value: this.initialValue,
      // value: null,
      valueDueStatus: null,
      valueFromDate: null,
      valueToDate: null,
      fromPastDue: null,
      toPastDue: null,
      dueStatus: null,
      options: this.options,
      isDisplayPopupCustomValue: false,
      error: null
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleHideDueStatus);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isKeepShow: false,
      isDisplayPopupCustomValue: false
    });

    if (nextProps.fromDate !== this.props.fromDate && nextProps.toDate === null) {
      let newValue = null;
      const newOptions = [...this.state.options];
      newOptions[1].label = 'Past due >= ' + nextProps.fromDate + ' days';
      newValue = nextProps.optionType
        ? newOptions.find(x => x.label)
        : newOptions[1];
      this.setState({
        // fromPastDue: nextProps.fromDate ? Number(nextProps.fromDate) : null,
        value: nextProps.fromDate ? newValue : null
      });
    }
    else if (nextProps.toDate !== this.props.toDate && nextProps.fromDate === null) {
      let newValue = null;
      const newOptions = [...this.state.options];
      newOptions[1].label = 'Past due <= ' + nextProps.toDate + ' days';
      newValue = nextProps.optionType
        ? newOptions.find(x => x.label)
        : newOptions[1];
      this.setState({
        // toPastDue: nextProps.toDate ? Number(nextProps.toDate) : null,
        value: nextProps.toDate ? newValue : null
      });
    }
    else if (nextProps.fromDate === null && nextProps.toDate === null) {
      let newValue = null;
      const newOptions = [...this.state.options];
      newOptions[1].label = 'Overdue';
      newValue = nextProps.optionType
        ? newOptions.find(x => x.label)
        : newOptions[1];
      this.setState({
        // dueStatus: nextProps.dueStatus ? nextProps.dueStatus : null,
        value: nextProps.dueStatus ? newValue : null
      });
    }
    else if (nextProps.fromDate !== this.props.fromDate && nextProps.toDate !== this.props.toDate) {
      if (Number(nextProps.fromDate) > Number(nextProps.toDate)) {
        let newValue = null;
        const newOptions = [...this.state.options];
        newOptions[1].label = 'Past due from ' + nextProps.toDate + ' to ' + nextProps.fromDate + ' days';
        newValue = nextProps.optionType
          ? newOptions.find(x => x.label)
          : newOptions[1];
        this.setState({
          // fromPastDue: nextProps.toDate ? nextProps.toDate : null,
          // toPastDue: nextProps.fromDate ? nextProps.fromDate : null,
          value: nextProps.fromDate && nextProps.toDate ? newValue : null
        });
      } else if (nextProps.fromDate === nextProps.toDate) {
        let newValue = null;
        const newOptions = [...this.state.options];
        newOptions[1].label = 'Past due = ' + nextProps.fromDate + ' days';
        newValue = nextProps.optionType
          ? newOptions.find(x => x.label)
          : newOptions[1];
        this.setState({
          // fromPastDue: nextProps.fromDate ? nextProps.fromDate : null,
          // toPastDue: nextProps.toDate ? nextProps.toDate : null,
          value: nextProps.fromDate && nextProps.toDate ? newValue : null
        });
      } else {
        let newValue = null;
        const newOptions = [...this.state.options];
        newOptions[1].label = 'Past due from ' + nextProps.fromDate + ' to ' + nextProps.toDate + ' days';
        newValue = nextProps.optionType
          ? newOptions.find(x => x.label)
          : newOptions[1];
        this.setState({
          // fromPastDue: nextProps.fromDate ? nextProps.fromDate : null,
          // toPastDue: nextProps.toDate ? nextProps.toDate : null,
          value: nextProps.fromDate && nextProps.toDate ? newValue : null
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleHideDueStatus);
  }

  callbackSelectPastDue = key => {
    let dueStatus = null;
    let fromDate = null;
    let toDate = null;
    if (key === 0) {
      dueStatus = 1;
      fromDate = null;
      toDate = null;
    // } else if (key === 2) {
    //   dueStatus = null;
    //   fromDate = 7;
    //   toDate = null;
    // } else if (key === 3) {
    //   dueStatus = null;
    //   fromDate = 14;
    //   toDate = null;
    // } else if (key === 4) {
    //   dueStatus = null;
    //   fromDate = 30;
    //   toDate = null;
    // } else if (key === 5) {
    //   dueStatus = null;
    //   fromDate = 60;
    //   toDate = null;
    }

    this.props.onSave(dueStatus, fromDate, toDate, this.state.value);
  };

  onSelectChange = e => {
    this.setState(
      {
        value: e.value,
        valueDueStatus: null,
        error: null,
        toPastDue: null,
        fromPastDue: null
      },
      () => {
        this.callbackSelectPastDue(e.value ? e.value.key : null);
      }
    );
  };

  onHoverValueCustom = () => {
    const offsetElement = this.customDueStatus.getBoundingClientRect();

    if (
      offsetElement.left + offsetElement.width >
      document.documentElement.clientWidth - 30
    ) {
      let className = this.customDueStatus.getAttribute('class');
      className += ' responsive';
      this.customDueStatus.setAttribute('class', className);
    } else {
      let className = this.customDueStatus.getAttribute('class');
      className.replace('responsive', '');
      this.customDueStatus.setAttribute('class', className);
    }

    this.setState({
      isKeepShow: true,
      isDisplayPopupCustomValue: true
    });
  };

  handleHideDueStatus = event => {
    if (this.state.isDisplayPopupCustomValue) {
      if (!this.customDueStatus.contains(event.target)) {
        this.setState({
          isKeepShow: false,
          isDisplayPopupCustomValue: false,
          error: null
        });
        if (
          !this.state.value ||
          (this.state.value &&
            this.state.value.key !== 6 &&
            this.state.valueDueStatus)
        ) {
          this.setState({
            valueDueStatus: null
          });
        }
      } else {
        this.setState({
          isKeepShow: true
        });
      }
    }
  };

  onHandleSubmit = (selected) => {
    if (selected.key === 6) {
      // this.onSetValueCustomPastDue(selected);
    } else {
      this.onSetValue(selected);
    }
  }
  onSetValue = (selected) => {
    const customAgeDueStatusOptions = [...this.state.options];
    customAgeDueStatusOptions.pop();
    customAgeDueStatusOptions.push({
      key: 1,
      value: 'Past due',
      label: 'Past due >= ' + selected.number + ' days'
    });
    this.setState(
      {
        options: customAgeDueStatusOptions,
        value: this.state.options[1],
        isDisplayPopupCustomValue: false,
        isKeepShow: false,
        valueDueStatus: null,
        valueFromDate: selected.number,
        valueToDate: null,
        fromPastDue: null,
        toPastDue: null
      },
      () => {
        this.props.onSave(
          this.state.valueDueStatus,
          this.state.valueFromDate,
          this.state.valueToDate,
          this.state.value
        );
      }
    );
  };

  onSetValueCustomPastDue = () => {
    const valueFromPastDue = this.state.fromPastDue;
    const valueToPastDue = this.state.toPastDue;

    if (valueFromPastDue === null && valueToPastDue !== null) {
      const customAgeDueStatusOptions = [...this.state.options];
      customAgeDueStatusOptions.pop();
      customAgeDueStatusOptions.push({
        key: 1,
        value: 'Past due',
        label: 'Past due <= ' + valueToPastDue + ' days'
      });
      this.setState(
        {
          options: customAgeDueStatusOptions,
          value: this.state.options[1],
          isDisplayPopupCustomValue: false,
          isKeepShow: false,
          valueDueStatus: null,
          valueFromDate: null,
          valueToDate: valueToPastDue
        },
        () => {
          this.props.onSave(
            this.state.valueDueStatus,
            this.state.valueFromDate,
            this.state.valueToDate,
            this.state.value
          );
        }
      );
    }
    if (valueFromPastDue !== null && valueToPastDue === null) {
      const customAgeDueStatusOptions = [...this.state.options];
      customAgeDueStatusOptions.pop();
      customAgeDueStatusOptions.push({
        key: 1,
        value: 'Past due',
        label: 'Past due >= ' + valueFromPastDue + ' days'
      });
      this.setState(
        {
          options: customAgeDueStatusOptions,
          value: this.state.options[1],
          isDisplayPopupCustomValue: false,
          isKeepShow: false,
          valueDueStatus: null,
          valueFromDate: valueFromPastDue,
          valueToDate: null
        },
        () => {
          this.props.onSave(
            this.state.valueDueStatus,
            this.state.valueFromDate,
            this.state.valueToDate,
            this.state.value
          );
        }
      );
    }
    if (valueFromPastDue === null && valueToPastDue === null || valueFromPastDue === 0 && valueToPastDue === 0) {
      const customAgeDueStatusOptions = [...this.state.options];
      customAgeDueStatusOptions.pop();
      customAgeDueStatusOptions.push({
        key: 1,
        value: 'Past due',
        label: 'Overdue'
      });
      this.setState(
        {
          options: customAgeDueStatusOptions,
          value: this.state.options[1],
          isDisplayPopupCustomValue: false,
          isKeepShow: false,
          valueDueStatus: 1,
          valueFromDate: null,
          valueToDate: null
        },
        () => {
          this.props.onSave(
            this.state.valueDueStatus,
            this.state.valueFromDate,
            this.state.valueToDate,
            this.state.value
          );
        }
      );
    }

    if (valueFromPastDue && valueToPastDue) {
      if (Number(valueFromPastDue) > Number(valueToPastDue)) {
        const customAgeDueStatusOptions = [...this.state.options];
        customAgeDueStatusOptions.pop();
        customAgeDueStatusOptions.push({
          key: 1,
          value: 'Past due',
          label: 'Past due from ' + valueToPastDue + ' to ' + valueFromPastDue + ' days'
        });
        this.setState(
          {
            options: customAgeDueStatusOptions,
            value: this.state.options[1],
            isDisplayPopupCustomValue: false,
            isKeepShow: false,
            valueDueStatus: null,
            valueFromDate: valueToPastDue,
            valueToDate: valueFromPastDue
          },
          () => {
            this.props.onSave(
              this.state.valueDueStatus,
              this.state.valueFromDate,
              this.state.valueToDate,
              this.state.value
            );
          }
        );
      } else if (Number(valueFromPastDue) === Number(valueToPastDue) && valueFromPastDue !== null && valueToPastDue !== null) {
        const customAgeDueStatusOptions = [...this.state.options];
        customAgeDueStatusOptions.pop();
        customAgeDueStatusOptions.push({
          key: 1,
          value: 'Past due',
          label: 'Past due = ' + valueToPastDue + ' days'
        });
        this.setState(
          {
            options: customAgeDueStatusOptions,
            value: this.state.options[1],
            isDisplayPopupCustomValue: false,
            isKeepShow: false,
            valueDueStatus: null,
            valueFromDate: valueToPastDue,
            valueToDate: valueFromPastDue
          },
          () => {
            this.props.onSave(
              this.state.valueDueStatus,
              this.state.valueFromDate,
              this.state.valueToDate,
              this.state.value
            );
          }
        );
      }
      else {
        const customAgeDueStatusOptions = [...this.state.options];
        customAgeDueStatusOptions.pop();
        customAgeDueStatusOptions.push({
          key: 1,
          value: 'Past due',
          label: 'Past due from ' + valueFromPastDue + ' to ' + valueToPastDue + ' days'
        });
        this.setState(
          {
            options: customAgeDueStatusOptions,
            value: this.state.options[1],
            isDisplayPopupCustomValue: false,
            isKeepShow: false,
            valueDueStatus: null,
            valueFromDate: valueFromPastDue,
            valueToDate: valueToPastDue
          },
          () => {
            this.props.onSave(
              this.state.valueDueStatus,
              this.state.valueFromDate,
              this.state.valueToDate,
              this.state.value
            );
          }
        );
      }
    }
  }

  onReset = () => {
    this.setState(
      {
        value: null,
        dueStatus: null,
        fromPastDue: null,
        toPastDue: null
      },
      () => {
        this.callbackSelectPastDue(null);
      }
    );
  };

  customRenderDueStatus = item => {
    if (item.key === 1) {
      return item.label;
    } else {
      return item.value;
    }
  };

  handleChangeFromPastDue = (e) => {
    const fromPastDue = e.target.value;
    if (fromPastDue <= 999) {
      if (fromPastDue >= 0) {
        this.setState({fromPastDue: e.target.value});
      } else {
        this.setState({fromPastDue: null});
      }
    }
  }

  handleChangeToPastDue = (e) => {
    const toPastDue = e.target.value;
    if (toPastDue <= 999) {
      if (toPastDue >= 0) {
        this.setState({toPastDue: e.target.value});
      } else {
        this.setState({toPastDue: null});
      }
    }
  }

  renderCustomPastDue = () => {
    return (
      <p style={{fontSize: 14, margin: 0}}>
        From <span className='overdue-block'>
          <input
            min='0'
            style={{width: 50}}
            className='overdue-input'
            ref={ref => {
              this.fromPastDue = ref;
            }}
            type='number'
            name='fromPastDue'
            onFocus={() => this.setState({fromPastDue: null})}
            value={this.state.fromPastDue || ''}
            onChange={this.handleChangeFromPastDue}
          />
        </span> days to <span className='overdue-block'>
          <input
            min='0'
            style={{width: 50}}
            className='overdue-input'
            ref={ref => {
              this.toPastDue = ref;
            }}
            type='number'
            name='toPastDue'
            onFocus={() => this.setState({toPastDue: null})}
            value={this.state.toPastDue || ''}
            onChange={this.handleChangeToPastDue}
          />
        </span> days <button style={{padding: '5px 5px', marginLeft: 3, marginBottom: 2}} className='btn btn-primary btn-siteone' onClick={this.onSetValueCustomPastDue}>OK</button>
      </p>
    );
  }

  customRenderItem = item => {
    const options = [{key: 2, text: '>= 7 days', value: 'Past due >= 7 days', number: 7},{key: 3, text: '>= 14 days', value: 'Past due >= 14 days', number: 14},{key: 4, text: '>= 30 days', value: 'Past due >= 30 days', number: 30},{key: 5, text: '>= 60 days', value: 'Past due >= 60 days', number: 60}, {key: 6, text: this.renderCustomPastDue(), value: this.renderCustomPastDue()}];
    if (item.key === 1) {
      return (
        <div
          className='custom-item'
          ref={ref => {
            this.customItem = ref;
          }}
        >
          {item.value}
          <i
            className='pe-7s-angle-right'
            style={{
              fontSize: 35,
              position: 'absolute',
              right: 0,
              top: '-45%'
            }}
          />

          <div
            style={{width: 225, height: 200}}
            className='custom-due-status box-form-siteone'
            ref={ref => {
              this.customDueStatus = ref;
            }}
            style={
              this.state.isDisplayPopupCustomValue
                ? null
                : { visibility: 'hidden' }
            }
          >
            <div className='col-sm-12 no-padding' style={{ marginTop: 10 }}>
              <div
                className='custom-group form-group col-sm-12 no-padding'
                style={{ marginBottom: 10}}
              >
                <ul style={{marginLeft: -25}}>
                  {options.map((el, index) =>
                    <li className={`select-past-due${index}`} onClick={() => this.onHandleSubmit(el)} key={index}>{el.text}</li>
                  )}
                </ul>
              </div>
              {this.state.error && (
                <div className='custom-group form-group col-sm-12 no-padding'>
                  <span
                    className='col-sm-12 no-padding text-danger'
                    style={{ wordBreak: 'break-all' }}
                  >
                    {this.state.error}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return item.value;
    }
  };

  render() {
    return (
      <div className='custom-date-range'>
        <div className={this.props.className} style={{ padding: 0 }}>
          <Dropdown
            onChange={this.onSelectChange}
            className='filestring-dropdown filter-dropdown'
            options={this.state.options}
            optionLabel='value'
            value={this.state.value}
            onHoverValue={1}
            onHoverLabel='key'
            onHoverItem={this.onHoverValueCustom}
            showClear={true}
            isKeepShow={this.state.isKeepShow}
            labelTemplate={this.customRenderDueStatus}
            itemTemplate={this.customRenderItem}
            placeholder='Any'
            style={{ width: '100%' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/due-status/index.js